// Shared Field Config utilities to prevent circular imports between
// templateInterpolation and repeaterKeywords.
export interface FieldConfigEntry {
  fieldid?: string;
  keywordId?: number;
  keywordName?: string;
  dataType?: string;
  fieldrequired?: boolean;
  uiLabel?: string;
  [key: string]: unknown;
}

export function findFieldById(fieldConfig: unknown, fieldid: string): FieldConfigEntry | undefined {
  // Handle both direct array and { fields: [...] } structures
  let fields: FieldConfigEntry[] | undefined;
  
  if (Array.isArray(fieldConfig)) {
    fields = fieldConfig as FieldConfigEntry[];
  } else if (fieldConfig && typeof fieldConfig === 'object' && 'fields' in fieldConfig) {
    const configObj = fieldConfig as { fields?: unknown };
    if (Array.isArray(configObj.fields)) {
      fields = configObj.fields as FieldConfigEntry[];
    }
  }
  
  if (!fields) return undefined;
  return fields.find(f => f?.fieldid === fieldid);
}

/**
 * Extract uiLabel from fieldConfig for a given fieldId, with fallback
 * @param fieldConfig - Array of field configuration objects
 * @param fieldId - Field identifier to search for
 * @param fallback - Default label if not found in config
 * @returns The uiLabel from config or fallback
 */
export function extractFieldLabel(fieldConfig: unknown, fieldId: string, fallback: string): string {
  const field = findFieldById(fieldConfig, fieldId);
  const label = field?.uiLabel;
  if (typeof label === 'string' && label.trim()) {
    return label.trim();
  }
  return fallback;
}
